<template lang="html">
  <StandardSnackbar
    :value="show"
    :color="color"
    @close="$emit(&quot;close&quot;)">
    <template v-slot:main>
      <slot name="text">
        {{ text }}
      </slot>
    </template>
    <template v-slot:closeButtonText>
      <v-icon>mdi-close</v-icon>
    </template>
  </StandardSnackbar>
</template>

<script>
import StandardSnackbar from './StandardSnackbar'

export default {
  components: {
    StandardSnackbar
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      text: 'There was an error processing your request',
      color: 'error'
    }
  }

}
</script>

<style lang="css" scoped>
</style>
